import React, { useState } from "react";
import MenuConfigurationTagsTable from "./MenuConfigurationTagsTable";
import MenuConfigurationTagsEditModal from "./MenuConfigurationTagsEditModal";

const MenuConfigurationTags = () => {
  const [openTagsEditModal, setOpenTagsEditModal] = useState(false);
  const [record, setRecord] = useState({});

  return (
    <>
      <MenuConfigurationTagsEditModal
        openTagsEditModal={openTagsEditModal}
        setOpenTagsEditModal={setOpenTagsEditModal}
        record={record}
        setRecord={setRecord}
      />
      <MenuConfigurationTagsTable
        setOpenTagsEditModal={setOpenTagsEditModal}
        setRecord={setRecord}
      />
    </>
  );
};

export default MenuConfigurationTags;
